export default "__VITE_ASSET__Dsf4vhXU__"